import React, { useContext } from 'react'
import Content from '../Content/Content'
import { style } from './Index.style'
import SectionTitle from '../SectionTitle/SectioinTitle'
import getConfig from 'next/config'
import { getCategoryJp } from '../../utils/news'
import { CategoryContext } from './CategoryContext'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

type OwnProps = {
  linkMedical: string
}

const Link = (props: OwnProps) => {
  const category = useContext(CategoryContext)

  return (
    <section css={[style.section, style.lastSection]}>
      <Content>
        <SectionTitle sectionSubTitle="LINK" sectionTitle="リンク" />
        <div css={style.buttons}>
          <a
            css={[style.button(category), style.disabled]}
            href=""
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>e-learning ページ入り口</span>
          </a>
          <a
            css={style.button(category)}
            href={`${basePath}/university/pdf/educational_programs.pdf`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{getCategoryJp(category)}大学の教育プログラム</span>
          </a>
          <a
            css={style.button(category)}
            href={props.linkMedical}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span>{getCategoryJp(category)}大学医学部</span>
          </a>
        </div>
      </Content>
    </section>
  )
}

export default Link
